import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  InputGroup,
  InputGroupPrepend,
  InputGroupText,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  TextInput,
} from '@met/react-components';
import React, { useEffect, useRef, useState } from 'react';

const AddApiApplicationModel = ({ hidden, toggle, onSaveClick }) => {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const nameRef = useRef(null);

  useEffect(() => {
    if (!hidden) nameRef.current.focus();
  }, [hidden, nameRef]);

  const handleSaveClick = () => {
    setSaving(true);
    onSaveClick(name)
      .then(() => setName(''))
      .then(() => setSaving(false));
  };

  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      handleSaveClick();
    }
  };

  return (
    <Modal centered hidden={hidden} toggle={toggle}>
      <ModalContent>
        <ModalHeader toggle={toggle}>
          <FontAwesomeIcon icon='code' /> Add API Application
        </ModalHeader>
        <ModalBody>
          <p>
            Add an API Application. Use this to enable leveraging the dotnet
            globabl intl cli tool.
          </p>
          <InputGroup>
            <InputGroupPrepend>
              <InputGroupText>Name</InputGroupText>
            </InputGroupPrepend>
            <TextInput
              inputRef={nameRef}
              placeholder='Name'
              value={name}
              onChange={e => setName(e.target.value)}
              onKeyPress={handleKeyPress}
            />
          </InputGroup>
        </ModalBody>
        <ModalFooter>
          <Button onClick={toggle}>Close</Button>
          <Button primary onClick={handleSaveClick} loading={saving}>
            Save Changes
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddApiApplicationModel;
